export default {
  common: {
    appName: 'ElderCare',
    loading: 'Загрузка...',
    retry: 'Повторить',
    goBack: 'На главную',
    logout: 'Выйти',
    save: 'Сохранить',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    delete: 'Удалить',
    edit: 'Редактировать',
    search: 'Поиск',
    weekDays: {
      sun: 'Вс',
      mon: 'Пн',
      tue: 'Вт',
      wed: 'Ср',
      thu: 'Чт',
      fri: 'Пт',
      sat: 'Сб',
    },
  },
  nav: {
    home: 'Главная',
    login: 'Вход',
    dashboard: 'Панель',
    health: 'Здоровье',
    medication: 'Лекарства',
    sos: 'Экстренный',
    family: 'Семья',
    article: 'Статьи',
    checkin: 'Отметка',
    settings: 'Настройки',
    about: 'О нас',
  },
  footer: {
    rights: 'Все права защищены',
    privacy: 'Политика конфиденциальности',
    terms: 'Условия использования',
  },
  index: {
    hero: {
      title: 'ElderCare - Умный хранитель здоровья для пожилых',
      subtitle: 'Платформа управления здоровьем для пожилых людей, позволяющая семьям быть в курсе и пожилым оставаться здоровыми',
      cta: 'Начать',
      learnMore: 'Узнать больше',
    },
    features: {
      title: 'Основные функции',
      health: { title: 'Мониторинг здоровья', desc: 'Отслеживайте артериальное давление, сахар и пульс с умными оповещениями' },
      medication: { title: 'Управление лекарствами', desc: 'Напоминания и проверка взаимодействий лекарств, больше никаких пропущенных доз' },
      sos: { title: 'Экстренный вызов', desc: 'SOS одним нажатием, автоматическое уведомление семьи и передача местоположения' },
      family: { title: 'Забота семьи', desc: 'Дистанционный мониторинг, мгновенные оповещения и обмен данными для семей' },
      article: { title: 'Статьи о здоровье', desc: 'Авторитетные медицинские знания и персонализированные руководства по здоровью' },
      checkin: { title: 'Ежедневная отметка', desc: 'Простой ежедневный учёт для формирования здоровых привычек' },
    },
    elderly: {
      title: 'Дизайн для пожилых',
      desc: 'Разработано для пожилых: легко использовать, видеть и нажимать',
      font: 'Крупный шрифт',
      touch: 'Большие области нажатия',
      contrast: 'Высококонтрастные цвета',
    },
  },
  login: {
    title: 'ElderCare',
    loginTab: 'Вход',
    registerTab: 'Регистрация',
    name: 'Имя',
    email: 'Эл. почта',
    password: 'Пароль',
    role: 'Я',
    elderRole: 'Пожилой',
    familyRole: 'Родственник',
    bindCode: 'Код привязки',
    bindCodeHint: 'Введите код привязки из аккаунта пожилого человека для связи и просмотра данных о здоровье',
    loginBtn: 'Войти',
    registerBtn: 'Зарегистрироваться',
    verifyHint: 'После регистрации на ваш адрес будет отправлено письмо подтверждения',
    error: 'Операция не удалась, попробуйте снова',
    nameTooShort: 'Имя должно содержать не менее 2 символов',
    emailInvalid: 'Введите корректный адрес электронной почты',
    passwordTooShort: 'Пароль должен содержать не менее 8 символов',
  },
  dashboard: {
    title: 'Панель здоровья',
    metrics: {
      bloodPressure: 'Артериальное давление',
      bloodSugar: 'Сахар крови',
      heartRate: 'Пульс',
      weight: 'Вес',
      sleep: 'Сон',
      temperature: 'Температура',
    },
    quickActions: 'Быстрые действия',
    recordHealth: 'Записать здоровье',
    takeMedicine: 'Принять лекарство',
    sos: 'Экстренный вызов',
    checkinStatus: 'Отметка сегодня',
    checkedIn: 'Отмечено сегодня',
    notCheckedIn: 'Не отмечено сегодня',
    goCheckin: 'Отметиться',
    medicationReminders: 'Напоминания о лекарствах',
    noReminders: 'Нет напоминаний о лекарствах',
    taken: 'Принято',
  },
  health: {
    title: 'Медицинские записи',
    inputTitle: 'Ввод данных',
    systolic: 'Систолическое (мм рт.ст.)',
    diastolic: 'Диастолическое (мм рт.ст.)',
    bloodSugar: 'Сахар крови (ммоль/л)',
    heartRate: 'Пульс (уд/мин)',
    weight: 'Вес (кг)',
    sleepHours: 'Сон (часы)',
    temperature: 'Температура (°C)',
    submit: 'Отправить запись',
    trend: 'Тренды',
    days: 'дней',
    aiAnalysis: 'ИИ-анализ здоровья',
    analyze: 'Анализировать',
    noAnalysis: 'Нажмите на кнопку выше, чтобы получить отчёт ИИ-анализа здоровья',
    history: 'История',
    noHistory: 'Нет истории',
    chartLabelSystolic: 'Систолическое давление',
  },
  medication: {
    title: 'Управление лекарствами',
    currentPlan: 'Текущий план',
    noMedications: 'Нет лекарств',
    addMedication: 'Добавить лекарство',
    name: 'Название лекарства',
    dosage: 'Дозировка',
    frequency: 'Частота',
    freqDaily: 'Раз в день',
    freqTwice: 'Два раза в день',
    freqThree: 'Три раза в день',
    freqWeekly: 'Раз в неделю',
    time: 'Время приёма',
    startDate: 'Дата начала',
    addBtn: 'Добавить',
    interactionWarning: 'Предупреждение о взаимодействии лекарств',
    noInteraction: 'Нет рисков взаимодействия лекарств',
    calendar: 'Календарь лекарств',
    invalidTimeFormat: 'Неверный формат времени, используйте HH:mm (напр., 08:00, 20:00)',
  },
  sos: {
    title: 'Экстренный вызов',
    holdToCall: 'Удерживайте для вызова',
    holdHint: 'Удерживайте 1 секунду для активации экстренного вызова',
    sent: 'Экстренный вызов отправлен',
    sentDesc: 'Ваши экстренные контакты уведомлены. Сохраняйте спокойствие и ждите помощи',
    contacts: 'Экстренные контакты',
    location: 'Текущее местоположение',
    loadingLocation: 'Определение местоположения...',
    locationUnavailable: 'Местоположение недоступно',
    history: 'История SOS',
    noHistory: 'Нет записей SOS',
    confirmed: 'Подтверждено',
    pending: 'Ожидание',
    sendFailed: 'Не удалось отправить экстренное оповещение, попробуйте снова',
    resolved: 'Решено',
  },
  family: {
    title: 'Забота семьи',
    members: 'Привязанная семья',
    noMembers: 'Нет привязанных родственников',
    bindCode: 'Код привязки',
    bindCodeHint: 'Поделитесь этим кодом с родственниками для привязки аккаунтов',
    invite: 'Пригласить родственника',
    email: 'Эл. почта родственника',
    relationship: 'Отношение',
    relSon: 'Сын',
    relDaughter: 'Дочь',
    relSpouse: 'Супруг(а)',
    relSibling: 'Брат/Сестра',
    relOther: 'Другое',
    inviteBtn: 'Отправить приглашение',
    notifications: 'Настройки уведомлений',
    prefAbnormal: 'Оповещение о нарушении здоровья',
    prefMedication: 'Напоминание о лекарствах',
    prefSos: 'Экстренное оповещение',
    prefWeekly: 'Еженедельный отчёт',
    prefCheckin: 'Уведомление об отметке',
    dataSharing: 'Обмен данными',
    shareDesc: 'Разрешить семье просматривать ваши данные о здоровье',
  },
  article: {
    title: 'Статьи о здоровье',
    search: 'Поиск статей...',
    noArticles: 'Статьи не найдены',
    expand: 'Читать далее',
    collapse: 'Свернуть',
    categories: {
      all: 'Все',
      heart: 'Сердечно-сосудистая система',
      diabetes: 'Диабет',
      bone: 'Кости',
      sleep: 'Сон',
      nutrition: 'Питание',
      exercise: 'Упражнения',
    },
  },
  checkin: {
    title: 'Ежедневная отметка',
    feeling: 'Как вы себя чувствуете сегодня?',
    feelings: {
      great: 'Отлично',
      good: 'Хорошо',
      normal: 'Нормально',
      bad: 'Плохо',
      terrible: 'Ужасно',
    },
    medication: 'Лекарства сегодня',
    yes: 'Да',
    no: 'Нет',
    diet: 'Оценка питания',
    dietRatings: {
      good: 'Хорошее',
      normal: 'Нормальное',
      poor: 'Плохое',
    },
    exercise: 'Упражнения сегодня',
    mood: 'Настроение',
    submit: 'Отправить отметку',
    streak: 'Серия',
    streakDays: 'дней',
    calendar: 'Календарь отметок',
  },
  settings: {
    title: 'Настройки',
    profile: 'Профиль',
    name: 'Имя пользователя',
    phone: 'Телефон',
    birthday: 'Дата рождения',
    emergencyContact: 'Экстренный контакт',
    save: 'Сохранить изменения',
    preferences: 'Предпочтения',
    language: 'Язык',
    theme: 'Тема',
    light: 'Светлая',
    dark: 'Тёмная',
    notifications: 'Уведомления',
    notifHealth: 'Оповещения о здоровье',
    notifMedication: 'Напоминания о лекарствах',
    notifSos: 'Экстренные оповещения',
    notifCheckin: 'Напоминания об отметке',
    bindCode: 'Мой код привязки',
    changePassword: 'Сменить пароль',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    changePasswordBtn: 'Сменить пароль',
    dangerZone: 'Опасная зона',
    deleteDesc: 'Удаление аккаунта необратимо. Все данные будут потеряны',
    deleteAccount: 'Удалить аккаунт',
    deleteConfirm: 'Вы уверены? Это действие необратимо!',
  },
  about: {
    title: 'О ElderCare',
    subtitle: 'Умный хранитель здоровья для пожилых',
    intro: 'Введение',
    introContent: 'ElderCare — платформа управления здоровьем для пожилых людей с умным мониторингом, управлением лекарствами, экстренными вызовами и многим другим, помогающая пожилым управлять своим здоровьем, оставаясь на связи с семьёй.',
    version: 'Информация о версии',
    versionNumber: 'Номер версии',
    buildDate: 'Дата сборки',
    acknowledgements: 'Благодарности',
    contact: 'Контакты',
    contactEmail: "q3300404157{'@'}gmail.com",
    privacy: 'Политика конфиденциальности',
    terms: 'Условия использования',
  },
  notfound: {
    message: 'Извините, страница, которую вы запрашиваете, не существует',
    goHome: 'На главную',
  },
  privacy: {
    title: 'Политика конфиденциальности',
    sections: {
      collection: {
        title: 'Сбор информации',
        content: 'Мы собираем только личную информацию, необходимую для предоставления услуг, включая регистрационные данные (электронная почта, имя), данные о здоровье (артериальное давление, сахар крови и другие показатели) и информацию об устройстве. Мы не собираем личную информацию, не связанную с нашими услугами.',
      },
      usage: {
        title: 'Использование информации',
        content: 'Ваша личная информация используется исключительно для предоставления и улучшения услуг, включая анализ данных о здоровье, оповещения об отклонениях, напоминания о лекарствах и другие основные функции. Мы не будем использовать вашу информацию в несанкционированных целях.',
      },
      storage: {
        title: 'Хранение информации',
        content: 'Ваши данные хранятся на защищённых облачных серверах с шифрованием передачи и хранения. Мы принимаем разумные технические меры для защиты безопасности ваших данных и предотвращения несанкционированного доступа.',
      },
      sharing: {
        title: 'Передача информации',
        content: 'Без вашего явного согласия мы не передаём вашу личную информацию третьим лицам. Данные о здоровье передаются привязанным членам семьи только после вашего разрешения на семейную связь.',
      },
      rights: {
        title: 'Ваши права',
        content: 'Вы имеете право на доступ, исправление и удаление вашей личной информации, а также на отзыв согласия. Вы можете реализовать эти права через настройки приложения или обратившись в нашу службу поддержки.',
      },
      security: {
        title: 'Безопасность',
        content: 'Мы используем шифрование и меры безопасности, соответствующие отраслевым стандартам, для защиты ваших данных, включая шифрованную передачу SSL, шифрованное хранение данных и контроль доступа. Мы регулярно проверяем и обновляем наши меры безопасности.',
      },
    },
  },
  terms: {
    title: 'Условия использования',
    sections: {
      acceptance: {
        title: 'Принятие условий',
        content: 'Используя данное приложение, вы соглашаетесь соблюдать настоящие условия использования. Если вы не согласны с какой-либо частью этих условий, пожалуйста, прекратите использование приложения. Мы оставляем за собой право изменять эти условия в любое время.',
      },
      service: {
        title: 'Описание сервиса',
        content: 'ElderCare предоставляет услуги помощи в управлении здоровьем, включая запись данных о здоровье, напоминания о лекарствах, экстренные вызовы и другие функции. Данный сервис предоставляется исключительно в справочных целях и не является медицинской консультацией, а также не может заменить профессиональные медицинские услуги.',
      },
      accounts: {
        title: 'Управление аккаунтом',
        content: 'Для использования основных функций приложения необходимо зарегистрировать аккаунт. Вы несёте ответственность за безопасность своего пароля и все действия, совершённые с вашего аккаунта. При обнаружении несанкционированного использования вашего аккаунта, пожалуйста, немедленно сообщите нам.',
      },
      data: {
        title: 'Данные и конфиденциальность',
        content: 'Мы придаем большое значение защите вашей конфиденциальности. Подробные правила обработки данных приведены в нашей Политике конфиденциальности. Вы сохраняете полный контроль над данными о здоровье, которые предоставляете.',
      },
      liability: {
        title: 'Ограничение ответственности',
        content: 'Информация о здоровье, предоставляемая данным приложением, носит исключительно справочный характер и не является медицинским диагнозом или рекомендацией по лечению. Мы не несём ответственности за убытки, возникшие в результате использования информации из данного приложения. При проблемах со здоровьем обращайтесь к квалифицированному медицинскому специалисту.',
      },
      changes: {
        title: 'Изменения условий',
        content: 'Мы можем периодически обновлять настоящие условия использования. Существенные изменения будут доводиться до вашего сведения через уведомления в приложении или по электронной почте. Продолжение использования данного приложения означает принятие обновлённых условий.',
      },
    },
  },
  feedback: {
    title: 'Обратная связь',
    subtitle: 'Ваш отзыв очень важен для нас',
    name: 'Имя',
    namePlaceholder: 'Введите ваше имя (необязательно)',
    email: 'Электронная почта',
    emailPlaceholder: 'Введите вашу электронную почту',
    subject: 'Тема',
    subjectGeneral: 'Общий отзыв',
    subjectBug: 'Сообщение об ошибке',
    subjectFeature: 'Предложение функции',
    subjectOther: 'Другое',
    message: 'Сообщение',
    messagePlaceholder: 'Подробно опишите ваш отзыв...',
    submit: 'Отправить отзыв',
    submitting: 'Отправка...',
    success: 'Отзыв успешно отправлен! Спасибо за ваш вклад',
    error: 'Не удалось отправить отзыв, попробуйте позже',
  },
  verify: {
    loading: 'Проверка вашей электронной почты...',
    success: 'Верификация успешна!',
    successDesc: 'Ваша электронная почта подтверждена. Теперь вы можете войти',
    failed: 'Верификация не удалась',
    failedDesc: 'Ссылка для подтверждения недействительна или устарела. Отправьте письмо повторно',
    resend: 'Отправить письмо повторно',
    resending: 'Отправка...',
    goLogin: 'Перейти к входу',
  },
  theme: {
    light: 'Светлая',
    dark: 'Тёмная',
  },
}
